import { FC, ReactNode } from 'react'

import {
  Text,
  FieldValidationError,
  GreyGrey50,
  Primary13Regular,
  Flex
} from '@sequencehq/core-components'
import { ValidationResult } from 'Automations/nodeDefinitions/validation'

export const FieldRow: FC<{
  label?: string
  children: ReactNode
  validationErrors?: ValidationResult[]
  'data-testid'?: string
}> = ({ label, children, validationErrors, 'data-testid': dataTestId }) => {
  return (
    <Flex flexDir="column" paddingX="4px" paddingY="6px" width="100%" gap="4px">
      <Flex alignItems="center" width="100%" gap="12px">
        {label && (
          <Text {...Primary13Regular} color={GreyGrey50}>
            {label}
          </Text>
        )}

        {children}
      </Flex>

      <FieldValidationError
        validationErrors={validationErrors}
        data-testid={dataTestId}
      />
    </Flex>
  )
}
